interface LogMeta {
  [key: string]: unknown;
}

const isDev = ((): boolean => {
  if (typeof import.meta !== 'undefined' && typeof import.meta.env !== 'undefined') {
    return Boolean(import.meta.env.DEV);
  }
  if (typeof process !== 'undefined' && process.env) {
    return process.env.NODE_ENV !== 'production';
  }
  return false;
})();

const serializeMeta = (meta?: LogMeta) => (meta && Object.keys(meta).length > 0 ? meta : undefined);

function log(level: 'debug' | 'info' | 'warn' | 'error', message: string, meta?: LogMeta) {
  const payload = serializeMeta(meta);
  switch (level) {
    case 'debug':
      if (isDev) console.debug(`[bam] ${message}`, payload ?? '');
      break;
    case 'info':
      console.info(`[bam] ${message}`, payload ?? '');
      break;
    case 'warn':
      console.warn(`[bam] ${message}`, payload ?? '');
      break;
    case 'error':
    default:
      console.error(`[bam] ${message}`, payload ?? '');
  }
}

export const logger = {
  debug: (message: string, meta?: LogMeta) => log('debug', message, meta),
  info: (message: string, meta?: LogMeta) => log('info', message, meta),
  warn: (message: string, meta?: LogMeta) => log('warn', message, meta),
  error: (message: string, meta?: LogMeta) => log('error', message, meta)
};

export type Logger = typeof logger;
